import React from "react";
import {GrCircleInformation} from "react-icons/gr";
import {HiOutlineSparkles} from "react-icons/hi2";
import {IoWarning} from "react-icons/io5";
import {MdOutlineDownloading, MdOutlinePendingActions} from "react-icons/md";
import {RiMegaphoneLine} from "react-icons/ri";
import {TbHexagonPlus} from "react-icons/tb";
import {VscVerifiedFilled} from "react-icons/vsc";
import type {AccountNotification} from "@/utils/notifications/account/types";

export function NotificationIcon({
    type,
    categoryKey,
}: {
    type: AccountNotification["type"];
    categoryKey?: string;
}) {
    if (categoryKey === "warning") {
        return (
            <IoWarning
                data-notification-icon="warning"
                className="size-5"
            />
        );
    }

    if (categoryKey === "news") {
        return (
            <RiMegaphoneLine
                data-notification-icon="news"
                className="size-5"
            />
        );
    }

    if (categoryKey === "feature") {
        return (
            <TbHexagonPlus
                data-notification-icon="feature"
                className="size-5"
            />
        );
    }

    if (categoryKey === "release_note" || type === "release_note") {
        return (
            <HiOutlineSparkles
                data-notification-icon="release-note"
                className="size-5"
            />
        );
    }

    if (type === "account_verified") {
        return (
            <VscVerifiedFilled
                data-notification-icon="account-verified"
                className="size-5"
            />
        );
    }

    if (type === "export_started") {
        return (
            <MdOutlinePendingActions
                data-notification-icon="export-started"
                className="size-5"
            />
        );
    }

    if (type === "export_ready") {
        return (
            <MdOutlineDownloading
                data-notification-icon="export-ready"
                className="size-5"
            />
        );
    }

    return (
        <GrCircleInformation
            data-notification-icon="fallback"
            className="size-5"
        />
    );
}
